/**
 * Analytics opcional para Facebook (solo relevante en app nativa con SDK).
 * Implementación no-op compartida: web-app y las actions en common no deben
 * importar desde mobile-app (Webpack no resuelve esa ruta).
 */

export const initializeFacebookSDK = () => {};

export const flushEvents = () => {};

export const logActivateApp = () => {};

export const logCompleteRegistration = () => {};

export const logBookingCreated = () => {};

export const logFirstTripCompleted = () => {};

export const logTripCompleted = () => {};

export const checkIfFirstTrip = async () => false;
